import React, { useState } from "react";
import {
  Container,
  AppBar,
  Toolbar,
  Typography,
  TextField,
  Button,
  Alert,
  Box,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Atras from "./atras";
import { auth } from "../firebase";

const SUPPORT_EMAIL = "support@notiline.com";

const FAQS = [
  {
    question: "¿Cómo publico un proyecto?",
    answer:
      "Desde el botón \"Publicar\" en la barra inferior, completá el título, la descripción, el presupuesto y la fecha de entrega. Los freelancers van a poder enviarte propuestas apenas lo publiques.",
  },
  {
    question: "¿Cómo envío una propuesta a un proyecto?",
    answer:
      "Entrá al proyecto que te interesa y tocá \"Enviar una propuesta\". Vas a poder proponer tu precio y un mensaje para el cliente.",
  },
  {
    question: "¿Puedo compartir mi WhatsApp o email en el chat?",
    answer:
      "No. Para proteger a la comunidad, no está permitido compartir información de contacto (teléfonos, emails o usuarios de redes sociales) para coordinar trabajo fuera de la plataforma. Hacerlo puede derivar en la suspensión o eliminación de tu cuenta.",
  },
  {
    question: "¿Qué son los planes de suscripción?",
    answer:
      "Los freelancers pueden suscribirse a un plan para acceder a más propuestas por mes, una insignia en su perfil y mejor posicionamiento en las búsquedas. Podés verlos y gestionarlos desde tu perfil, en \"Suscripción\".",
  },
  {
    question: "¿Cómo cambio mi contraseña?",
    answer:
      "Andá a tu perfil y tocá \"Cambiar contraseña\". Te vamos a pedir tu contraseña actual y la nueva contraseña.",
  },
  {
    question: "¿Cómo elimino mi cuenta?",
    answer:
      "Desde tu perfil, tocá \"Eliminar cuenta\". Es una acción permanente: vas a perder acceso a tus proyectos, propuestas y chats, así que te vamos a pedir tu contraseña y una confirmación explícita antes de borrarla.",
  },
  {
    question: "¿Cuánto tardan en responder mis consultas?",
    answer:
      "Normalmente respondemos las consultas por email en menos de 48 horas hábiles.",
  },
];

const HelpSupport = () => {
  const [name, setName] = useState(auth.currentUser?.displayName || "");
  const [email, setEmail] = useState(auth.currentUser?.email || "");
  const [subject, setSubject] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState(null);

  const handleSubmit = (event) => {
    event.preventDefault();
    setError(null);

    if (!name || !email || !message) {
      setError("Completá tu nombre, email y mensaje antes de enviar.");
      return;
    }

    const body = `${message}\n\n---\nNombre: ${name}\nEmail: ${email}`;
    const mailtoUrl = `mailto:${SUPPORT_EMAIL}?subject=${encodeURIComponent(
      subject || "Consulta desde la app"
    )}&body=${encodeURIComponent(body)}`;

    window.location.href = mailtoUrl;
  };

  return (
    <Container>
      <AppBar position="fixed">
        <Toolbar sx={{ display: "flex", alignItems: "center", gap: 2 }}>
          <Atras />
          <Typography variant="h6" color="text.primary">
            Ayuda y Soporte
          </Typography>
        </Toolbar>
      </AppBar>
      <Container maxWidth="sm" sx={{ mt: 15, mb: 14 }}>
        <Typography variant="h6" gutterBottom>
          Preguntas frecuentes
        </Typography>
        {FAQS.map(({ question, answer }) => (
          <Accordion key={question} disableGutters>
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Typography fontWeight={600}>{question}</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography variant="body2" color="text.secondary">
                {answer}
              </Typography>
            </AccordionDetails>
          </Accordion>
        ))}

        <Typography variant="h6" sx={{ mt: 5 }} gutterBottom>
          Contactanos
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          ¿No encontraste lo que buscabas? Escribinos y te respondemos a{" "}
          {SUPPORT_EMAIL}.
        </Typography>

        {error && (
          <Alert severity="error" sx={{ mb: 2 }}>
            {error}
          </Alert>
        )}

        <Box component="form" onSubmit={handleSubmit}>
          <TextField
            label="Tu nombre"
            fullWidth
            margin="normal"
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
          <TextField
            label="Tu email"
            type="email"
            fullWidth
            margin="normal"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <TextField
            label="Asunto"
            fullWidth
            margin="normal"
            value={subject}
            onChange={(e) => setSubject(e.target.value)}
          />
          <TextField
            label="Mensaje"
            fullWidth
            multiline
            rows={4}
            margin="normal"
            value={message}
            onChange={(e) => setMessage(e.target.value)}
          />
          <Box sx={{ mt: 2 }}>
            <Button type="submit" variant="contained" fullWidth>
              Enviar consulta
            </Button>
          </Box>
        </Box>
      </Container>
    </Container>
  );
};

export default HelpSupport;
